// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1T26J","label":"LabeledBox_label__2AFw2"};